export const types = {
    //Auth
    authLogin: '[Auth Login] Cargar datos de inicio de sesión del usuario',
    authRefresh: '[Auth Refresh] Renovar token y fecha de expiración',
    logoutLogin:
        '[Logout Login] Elimina los datos cargados de sesion del usuario',
    validationToken:
        '[Validation Token] Validar el token activo de la sesión del usuario',
    validationGeolocation:
        '[Validation Geolocation] Validar la geolocalización de la sesión del usuario',

    //General
    uploadStatus: '[Upload Status] Cargar todos los estados al redux',
    uploadChannels: '[Upload Channels] Cargar todos los canales al redux',
    uploadUserLog:
        '[Upload UserLog] Cargar toda la información del usuario al redux',
    blockPages:
        '[Block Pages] Cargar toda la información de las páginas bloqueadas al redux',
    questionDependency:
        '[Question Dependency] Cargar toda la información de las preguntas de dependencia en las encuestas',

    //Stepper
    nextStepper: '[Next Stepper] Carga el siguiente formulario del stepper',
    backStepper: '[Back Stepper] Carga el anterior formulario del stepper',
    resetStepper: '[Reset Stepper] Carga el formulario inicial del del stepper',
    uploadIpOrigin: '[Upload Ip Origin] Cargar la ip del cliente al redux',
};
